module.exports = __webpack_public_path__ + "static/media/cl.979056b8.svg";